// extracted by mini-css-extract-plugin
module.exports = {"typeChipContainer":"styles_typeChipContainer__336-B","typeChipRow":"styles_typeChipRow__2tV4l"};